import { useEffect, useState } from 'react';
import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import styles from './AnimatedBanner.module.css';

import type { FC, HTMLAttributes } from 'react';

type AnimatedBannerProps = HTMLAttributes<HTMLDivElement>;

const AnimatedBanner: FC<AnimatedBannerProps> = (props) => {
  const { className, ...restProps } = props;
  const [scrolled, setScrolled] = useState(false);
  const { t } = useTranslation();
  const title = t('banner.title');
  const description = t('banner.description');

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) setScrolled(true);
      if (window.scrollY <= 50) setScrolled(false);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={cn(styles.banner, className)} {...restProps}>
      <div className={styles.container}>
        <div className={styles.description}>{description}</div>
        <div className={styles.title}>{title}</div>
        <div className={cn(styles.image, { [styles.zoom]: scrolled })} />
      </div>
    </div>
  );
};

export default AnimatedBanner;
